import { Box, Dialog, styled, Typography } from '@mui/material'

export const StyledDialog = styled(Dialog)`
  & .MuiPaper-root {
    background-color: ${({ theme }) => theme.palette.custom.white};
    display: flex;
    flex-direction: column;
    align-items: stretch;
    padding: 18px 24px 7px;
    max-width: 621px;
    border-radius: 5px;
    box-shadow: 0 16px 26px rgba(5, 19, 80, 0.07);
  }
`

export const Header = styled(Box)`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 15px;
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom.blue1};
  font-size: 16px;
  font-weight: 500;
`

export const Text = styled(Typography)`
  color: ${({ theme }) => theme.palette.custom.blue1};
  font-size: 15px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 30px;
`

export const Products = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: stretch;
  margin-bottom: 16px;
`

export const ProductWrapper = styled(Box)`
  flex: 1;
  border-radius: 6px;
  overflow: hidden;
`

export const IconWrapper = styled(Box)`
  margin: 0 4px;
`
